import seriesProcessor from "./seriesProcessor.js";
import getColor from "./getColor.js";
import legendGetter from "./legend.js";
import tooltipGetter from "./tooltip.js";
import seriesLayout from "./seriesLayout.js";
import getSeriesWithDefaultValues from "./getSeriesWithDefaultValues.js";
import tooltipItemPositionGetter from "./tooltipPosition.js";
import keyboardFocusHandler from "./keyboardFocusHandler.js";
import { identifierSerializerSeriesIdDataIndex } from "../../internals/identifierSerializer.js";
export const pieSeriesConfig = {
  colorProcessor: getColor,
  seriesProcessor,
  seriesLayout,
  legendGetter,
  tooltipGetter,
  tooltipItemPositionGetter,
  getSeriesWithDefaultValues,
  keyboardFocusHandler,
  identifierSerializer: identifierSerializerSeriesIdDataIndex
};